export default __webpack_public_path__ + "static/whats-new-in-swarmia-d8e324dba3db572833c6146b5dc69a24.png";